<template lang="pug" src="./accessibility.pug"></template>

<script>

export default {
  computed: {
    props () {
      return this.$store.state.pages.contact
    },
    loading () {
      return this.$store.state.loading
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('VIEW_NAV', false)
    next()
  },
  components: {
  },
  data () {
    return {
      companyName: 'Genesis Orthodontics', // Fill this in
      domain: "<a href='https://www.genesisorthodontics.com'>genesisorthodontics.com</a>", // Fill this in
      email: "<a href='mailto:office@genesisorthodontics.com'>office@genesisorthodontics.com</a>", // Fill this in
      phone: "<a href='tel:1-402-488-5275'>402.488.5275</a>",
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/accessibility/accessibility.vue